module.exports = ".row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f2f2f2;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/recovery/Renewals/renewals-form/renewals-form.component.css
// module id = ./src/app/recovery/Renewals/renewals-form/renewals-form.component.css
// module chunks = main